$ ->
  $navButtons = $('[data-navbar-btn]')
  $navItems = $('[data-navbar-item]')
  $overlay = $('<div data-navbar-overlay="close" />')
  openMenuBtn = null
  mouseoutTimer = false
  blurTimer = false

  useMobile = ->
    $('[data-mobilenav="toggle"]').is(':visible')

  setOpenMenu = ($expandedNav) =>
    openMenuBtn = $expandedNav.get(0)

  checkForOpenNav = () =>
    $expandedNav = $navButtons.filter('[data-aria-expanded="true"]').first()
    if $expandedNav.length > 0
      $navItems.filter( '.active' ).addClass( 'js-off-active' ).removeClass( 'active' )
      setOpenMenu($expandedNav)
    else
      $navItems.filter( '.js-off-active' ).addClass( 'active' ).removeClass( 'js-off-active' )

  updateNavItems = ($el, newState) =>
    $el.toggleClass 'is-open', newState == 'open'
    $el.find '[data-aria-expanded]'
       .attr 'data-aria-expanded', newState == 'open'
       .attr 'aria-expanded', newState == 'open'
    $overlay
      .height $(document).height()
      .attr 'data-navbar-overlay', newState
    checkForOpenNav()

  $('body').append($overlay)

  $('body').on 'mouseup', (e) =>
    return if !$('[data-navbar-btn][data-aria-expanded="true"]').length > 0
    if (e.target != openMenuBtn)
      openMenuBtn = null
      updateNavItems($navItems, 'close')
      $navItems.blur()

  $('body').on 'touchend', (e) =>
    return if !$('[data-navbar-btn][data-aria-expanded="true"]').length > 0
    $link = e.target.href && $(e.target) ||
            $(e.target).closest("a").length && $(e.target).closest("a[href!='']")
    if ($link)
      window.open $link.attr("href"), $link.attr("target")
    else if (e.target != openMenuBtn)
      openMenuBtn = null
      updateNavItems($navItems, 'close')
      $navItems.blur()

  $navItems
    .on 'mouseover', (e) ->
      return if useMobile()
      $this = $(@)
      updateNavItems($navItems.not($this), 'close')
      updateNavItems($this, 'open')
      clearTimeout(mouseoutTimer)
    .on 'mouseout', ->
      return if useMobile()
      mouseoutTimer = setTimeout (() ->
        updateNavItems($navItems, 'close')
        return
      ), 500
    .on 'focusout', ->
      return if useMobile()
      blurTimer = setTimeout (() ->
        updateNavItems($navItems, 'close')
        return
      ), 100
    .on 'focusin', ->
      return if useMobile()
      clearTimeout(blurTimer)

  $navButtons.attr
    'aria-expanded': false
    'data-aria-expanded': false
    'aria-haspopup': 'true'

  $navButtons
    .on 'mousedown', (e) ->
      e.preventDefault()
      $('body').trigger 'App::Components::Mobilenav::toggle' if useMobile()
    .on 'focus', (e) ->
      return if useMobile()
      $parent = $(@).closest('[data-navbar-item]')
      updateNavItems($navItems.not($parent), 'close')
    .on 'mouseenter', (e) ->
      $navItems.find(':focus').not(@).blur()

    # Click could be broken into keyboard events, but for now 
    # we'll use click as a catch-all to interpret mapped touch and keyboard behavior.
    .on 'touchend keydown', (e) ->
      return if (e.type == 'keydown' && !(e.keyCode == 32 || e.keyCode == 13))
      e.preventDefault()
      $btn = $(e.target)
      if useMobile()
        $('body').trigger 'App::Components::Mobilenav::toggle'
      else
        newState = if $btn.attr('data-aria-expanded') == 'true' then 'close' else 'open'
        $navItem = $btn.closest('[data-navbar-item]')
        updateNavItems($navItems.not($navItem), 'close') if newState == 'open'
        updateNavItems($navItem, newState)
      return